import { H2, Text, VStack } from '@montel/montelpro-shared-components-v2';
import CompanyLevelFormContextProvider from './CompanyLevel/CompanyLevelFormContext';
import CompanyLevelForm from './CompanyLevel/CompanyLevelForm';
import CompanyLevelTable from './CompanyLevel/CompanyLevelTable';
import UserLevelFormContextProvider from './UserLevel/UserLevelFormContext';
import UserLevelForm from './UserLevel/UserLevelForm';
import UserLevelTable from './UserLevel/UserLevelTable';
import SectionDivider from 'components/common/SectionDivider';

const ProviderAccessExportPage = () => (
	<VStack fullWidth>
		<H2>Company level access</H2>
		<Text>
			All accesses by company active at any time during specified period
		</Text>
		<VStack fullWidth>
			<CompanyLevelFormContextProvider>
				<CompanyLevelForm />
				<CompanyLevelTable />
			</CompanyLevelFormContextProvider>
		</VStack>
		<SectionDivider />
		<H2>User level access</H2>
		<Text>
			All accesses by user active at any time during specified period
		</Text>
		<VStack fullWidth>
			<UserLevelFormContextProvider>
				<UserLevelForm />
				<UserLevelTable />
			</UserLevelFormContextProvider>
		</VStack>
	</VStack>
);

export default ProviderAccessExportPage;
